import { Box, Typography } from "@mui/material";

export const PlannedShredChart = ({
  productGroupName,
  tenants,
  color,
}: {
  productGroupName: string;
  tenants: { tenantName: string; shredFraction: number }[];
  color: string;
}) => {
  const maxFraction = Math.max(...tenants.map((t) => t.shredFraction), 0);

  return (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 0.5 }}>
        {productGroupName}
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "max-content max-content 1fr",
          columnGap: 0.25,
          rowGap: 0.25,
          alignItems: "center",
        }}
      >
        {tenants.map((t) => {
          const widthPct =
            maxFraction > 0 ? (t.shredFraction / maxFraction) * 100 : 0;
          return [
            <Typography
              key={`${t.tenantName}-name`}
              variant="caption"
              fontWeight="bold"
              sx={{ whiteSpace: "nowrap" }}
            >
              {t.tenantName}
            </Typography>,
            <Typography
              key={`${t.tenantName}-pct`}
              variant="caption"
              sx={{ whiteSpace: "nowrap" }}
            >
              {(t.shredFraction * 100).toFixed(1)}%
            </Typography>,
            <Box
              key={`${t.tenantName}-bar`}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Box
                sx={{
                  height: 10,
                  width: `${widthPct}%`,
                  bgcolor: color,
                  borderRadius: 0.5,
                  minWidth: widthPct > 0 ? 2 : 0,
                }}
              />
            </Box>,
          ];
        })}
      </Box>
    </Box>
  );
};
